// Integrated controller for font purchasing form with variant selection
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["allCheckbox", "variantCheckbox"];

    connect() {
        // 최초 설정값 적용 및 submit 처리 1회 해주기.
        // 구매 영역 프레임(purchase_panel)이 교체될 때는 렌더 도중에 connect 되는데, 그 자리에서 바로
        // 제출하면 Turbo 가 요청을 끝내지 못해 가격 계산이 멈춘다. 렌더가 끝난 다음 틱으로 미룬다.
        setTimeout(() => this.toggleVariant(), 0);
    }

    // Form submission - inherited from components/form_controller
    submit(_e) {
        this.element.requestSubmit();
    }

    // Toggle all variants when "select all" checkbox is clicked
    toggleAll() {
        const isAllSelected = this.allCheckboxTarget.checked;

        this.variantCheckboxTargets.forEach(checkbox => {
            checkbox.checked = isAllSelected;
        });

        this.submit();
    }

    // Handle individual variant checkbox changes
    toggleVariant() {
        this.updateAllCheckboxState();
        this.submit();
    }

    // Update the "select all" checkbox state based on individual selections
    updateAllCheckboxState() {
        if (!this.hasAllCheckboxTarget) return;

        const totalVariants = this.variantCheckboxTargets.length;
        const checkedVariants = this.variantCheckboxTargets.filter(cb => cb.checked).length;

        this.allCheckboxTarget.checked = (checkedVariants === totalVariants && totalVariants > 0);
    }
}